import { useHotkeys } from 'react-hotkeys-hook';
import { Key } from 'ts-key-enum';

type UseOnboardingClinicianTypeSelectHotkeysParams = {
  open: boolean;
  isShortcutsDisabled: boolean;
  displaySpecialties: Array<{ id: string }>;
  highlightedIndex: number;
  setIsKeyboardMode: (value: boolean) => void;
  setHighlightedIndex: React.Dispatch<React.SetStateAction<number>>;
  setOpen: (value: boolean) => void;
  onSpecialtySelected: (specialtyId: string) => void;
  stop: () => void;
};

export function useOnboardingClinicianTypeSelectHotkeys({
  open,
  isShortcutsDisabled,
  displaySpecialties,
  highlightedIndex,
  setIsKeyboardMode,
  setHighlightedIndex,
  setOpen,
  onSpecialtySelected,
  stop,
}: UseOnboardingClinicianTypeSelectHotkeysParams) {
  const hotkeyOpts = { enableOnFormTags: true, enabled: !isShortcutsDisabled };

  useHotkeys(
    Key.ArrowDown,
    (e) => {
      if (!open || isShortcutsDisabled) return;
      e.preventDefault();
      setIsKeyboardMode(true);
      setHighlightedIndex((prev) =>
        prev < displaySpecialties.length - 1 ? prev + 1 : prev
      );
    },
    hotkeyOpts,
    [open, isShortcutsDisabled, displaySpecialties.length]
  );
  useHotkeys(
    Key.ArrowUp,
    (e) => {
      if (!open || isShortcutsDisabled) return;
      e.preventDefault();
      setIsKeyboardMode(true);
      setHighlightedIndex((prev) => (prev > 0 ? prev - 1 : prev));
    },
    hotkeyOpts,
    [open, isShortcutsDisabled]
  );
  useHotkeys(
    Key.Enter,
    (e) => {
      if (!open || isShortcutsDisabled) return;
      e.preventDefault();
      if (displaySpecialties[highlightedIndex]) {
        onSpecialtySelected(displaySpecialties[highlightedIndex].id);
      }
    },
    hotkeyOpts,
    [open, isShortcutsDisabled, displaySpecialties, highlightedIndex, onSpecialtySelected]
  );
  useHotkeys(
    Key.Escape,
    () => {
      if (open) {
        setOpen(false);
        stop();
      }
      if (
        document.activeElement?.tagName === 'INPUT' &&
        document.activeElement &&
        'blur' in document.activeElement
      ) {
        (document.activeElement as HTMLElement).blur();
      }
    },
    { enableOnFormTags: ['INPUT', 'TEXTAREA'], enabled: !isShortcutsDisabled },
    [open, stop, isShortcutsDisabled]
  );
}
